import { useEffect, useState } from 'react';

type useNavigatorPermissionsInterface = {
  /** The permission status. This will be an empty string if it's still fetching. */
  permission: string;
  /** Returns true if the navigator api encounters an issue. */
  error: boolean;
};

const useNavigatorPermissions = (
  /** The name of the API you'd like to query. */
  name: PermissionName,
  /** Reference: https://developer.mozilla.org/en-US/docs/Web/API/Permissions/query */
  configuration?: object,
): useNavigatorPermissionsInterface => {
  const [error, setError] = useState(false);
  const [permission, setPermission] = useState('');

  useEffect(() => {
    let permissionInstance: PermissionStatus | null = null;

    if (window && window.navigator && navigator.permissions) {
      navigator.permissions
        .query({ name, ...configuration })
        .then((permissionStatus) => {
          permissionInstance = permissionStatus;

          setPermission(permissionStatus.state);

          permissionInstance.onchange = () => {
            setPermission(permissionStatus.state);
          };
        });
    } else {
      setError(true);
    }

    return () => {
      if (permissionInstance) {
        permissionInstance.onchange = null;
      }
    };
  }, [name, configuration]);

  return { permission, error };
};

export default useNavigatorPermissions;
